import { marketsDevScriptLib } from "./markets-script-dev-lib";
import { watchUpdates } from "@fanfanlo";
import { marketsScriptLib } from "./markets-script-lib";

let isInitialized = false;
function init(){
    if(isInitialized){
        return;
    }
    isInitialized = true;
    marketsDevScriptLib.init();
    marketsScriptLib.init();
    watchUpdates(marketsDevScriptLib.marketDevLibData, (data)=>{
        console.log('marketsDevScriptLib.devLibInfo=', data);
        const allMarktLibData = marketsDevScriptLib.marketDevLibData.allMarketLibData;
        if(!allMarktLibData)return;
        for(const html of allMarktLibData.htmls){
            marketsScriptLib.lib[html.client.ns] = html;
            
        }
        for(const script of allMarktLibData.resources){
            marketsScriptLib.lib[script.client.ns] = script;
        }
    });
}
export const marketsScriptManager = {
    init,
}
